import { render, staticRenderFns } from "./searchFor.vue?vue&type=template&id=1f5c13f2&scoped=true"
import script from "./searchFor.vue?vue&type=script&lang=js"
export * from "./searchFor.vue?vue&type=script&lang=js"
import style0 from "./searchFor.vue?vue&type=style&index=0&id=1f5c13f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5c13f2",
  null
  
)

export default component.exports